class ErgoMattressInteraction extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.blocks = null;
    this.wrapperHeight = null;
    this.pointerContainer = null;
  }

  connectedCallback() {
    this.blocks = this.querySelectorAll(".mattress-block-container");
    this.wrapperHeight = this.querySelector(".mattress-calculated-height");
    this.pointerContainer = this.querySelector(".mattress-pointer-container");

    if (!this.blocks || !this.wrapperHeight) return;

    this.wrapperHeight.style.height = `${this.blocks.length}00vh`;

    this.animateSection();
    window.addEventListener("resize", this.animateSection);

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener("scroll", this.animateSection);
        } else {
          window.removeEventListener("scroll", this.animateSection);
        }
      });
    });

    this.observer.observe(this); 
  }

  animateSection = () => {
    const heightDividedByBlocks =
      this.wrapperHeight.offsetHeight / this.blocks.length;
    const bottom = this.wrapperHeight.getBoundingClientRect().bottom;
    let currentBlockReversedIndex = Math.floor(bottom / heightDividedByBlocks);

    const reversedBlocks = [...this.blocks].reverse();
    reversedBlocks.forEach((block, index) => {
      if (index === currentBlockReversedIndex - 1) {
        block.classList.add("active");
        this.pointerContainer.style.height = `${block.getAttribute(
          "data-percentage"
        )}%`;
      } else if (currentBlockReversedIndex == 0 && index == 0) {
        block.classList.add("active");
        this.pointerContainer.style.height = `${block.getAttribute(
          "data-percentage"
        )}%`;
      } else {
        block.classList.remove("active");
      }
    });
  };
}

if (!customElements.get("ergo-mattress-interaction")) {
  customElements.define("ergo-mattress-interaction", ErgoMattressInteraction);
}
